import {
  EditorColorScheme,
  PortalBgType,
  PortalBorderType,
  PortalShadowType,
  PortalTextType,
  PortalThemeColors,
  TailwindCommonPalette,
  TailwindExtraPalette,
} from '@nx-frontend/shared/types';

export const ThemeTheDarkNight: PortalThemeColors = {
  key: 'dark_night',
  iconSet: 'default',
  name: 'The Dark Night',
  thumbnail: '/assets/img/themes/dark-night/dark-night.png',
  preview: '/assets/img/themes/dark-night/dark-night-preview-full.png',
  description: 'A modern dark theme featuring sophisticated light blue accents',
  icon: '/assets/img/icon-dark.svg',
  logo: '/assets/img/k-logo-dark.svg',
  editorColor: EditorColorScheme.DARK,
  comingSoon: false,
  imagesHead: { enabled: true, base: { url: '/assets/img/dark-portal-bg.png' } },
  [PortalBgType.HEADER]: [TailwindCommonPalette.TRANSPARENT],
  [PortalBgType.HEADER_MENU]: [TailwindCommonPalette.TRANSPARENT],
  [PortalBgType.BODY]: [TailwindCommonPalette.NEUTRAL_900],
  [PortalBgType.FOOTER]: [TailwindCommonPalette.NEUTRAL_900],
  [PortalBgType.PRIMARY]: [TailwindCommonPalette.CYAN_500],
  [PortalBgType.SECONDARY]: [TailwindCommonPalette.CYAN_700, TailwindCommonPalette.CYAN_500],
  [PortalTextType.HERO_TEXT]: [TailwindCommonPalette.WHITE],
  [PortalBgType.GREETING_1]: [TailwindCommonPalette.WHITE, TailwindExtraPalette.WHITE_75, ['bg-gradient-to-b']],
  [PortalBgType.GREETING_2]: [TailwindCommonPalette.WHITE, TailwindExtraPalette.WHITE_75, ['bg-gradient-to-b']],
  [PortalBgType.SURFACE]: [TailwindCommonPalette.NEUTRAL_800],
  [PortalBgType.SURFACE_TEXT]: [TailwindCommonPalette.WHITE, TailwindExtraPalette.WHITE_50],
  [PortalBgType.SURFACE_VARIANT]: [TailwindCommonPalette.NEUTRAL_800],
  [PortalBgType.SURFACE_INNER]: [TailwindCommonPalette.NEUTRAL_800],
  [PortalBgType.SURFACE_INNER_VARIANT]: [TailwindCommonPalette.NEUTRAL_700],
  [PortalBgType.SURFACE_INNER_VARIANT_2]: [TailwindCommonPalette.NEUTRAL_700],
  [PortalBgType.SURFACE_INNER_VARIANT_HOVER_2]: [TailwindCommonPalette.NEUTRAL_700],
  [PortalBgType.HEADER_HOVER]: [TailwindCommonPalette.NEUTRAL_700],
  [PortalBgType.BODY_HOVER]: [TailwindCommonPalette.NEUTRAL_700],
  [PortalBgType.SURFACE_VARIANT_HOVER]: [TailwindCommonPalette.NEUTRAL_700],
  [PortalBgType.SURFACE_INNER_HOVER]: [TailwindCommonPalette.NEUTRAL_700],
  [PortalBgType.SURFACE_INNER_HOVER_2]: [TailwindCommonPalette.NEUTRAL_600],
  [PortalBgType.PRIMARY_HOVER]: [TailwindCommonPalette.CYAN_300],
  [PortalBgType.SECONDARY_HOVER]: [TailwindCommonPalette.CYAN_600, TailwindCommonPalette.CYAN_400],
  [PortalBgType.TOOLTIP]: [TailwindCommonPalette.NEUTRAL_900],
  [PortalBgType.FOOTER_LINE]: [TailwindCommonPalette.TRANSPARENT],
  [PortalBgType.FOOTER_DIVIDER]: [TailwindCommonPalette.NEUTRAL_300],
  [PortalBgType.FILL_SURFACE]: [TailwindCommonPalette.NEUTRAL_300],
  [PortalBgType.FILL_SURFACE_2]: [TailwindCommonPalette.NEUTRAL_300],
  [PortalBgType.FOOTER_LINKS]: [TailwindCommonPalette.WHITE],
  [PortalBgType.FOOTER_LINKS_HOVER]: [TailwindCommonPalette.CYAN_300],
  [PortalBgType.HEADER_LINKS]: [TailwindCommonPalette.TRANSPARENT],
  [PortalBgType.EDIT_BG]: [TailwindCommonPalette.NEUTRAL_800],
  [PortalTextType.SURFACE]: [TailwindCommonPalette.WHITE],
  [PortalBgType.SURFACE_DISABLE]: [TailwindCommonPalette.NEUTRAL_600],
  [PortalBorderType.SURFACE_DISABLE]: [TailwindCommonPalette.NEUTRAL_400],
  [PortalTextType.SURFACE_DISABLE]: [TailwindCommonPalette.NEUTRAL_400],
  [PortalTextType.SURFACE_2]: [TailwindCommonPalette.WHITE],
  [PortalTextType.SURFACE_3]: [TailwindCommonPalette.NEUTRAL_300],
  [PortalTextType.SURFACE_VARIANT]: [TailwindCommonPalette.WHITE],
  [PortalTextType.SURFACE_VARIANT_2]: [TailwindCommonPalette.NEUTRAL_300],
  [PortalTextType.SURFACE_INNER]: [TailwindCommonPalette.WHITE],
  [PortalTextType.SURFACE_INNER_2]: [TailwindCommonPalette.NEUTRAL_300],
  [PortalTextType.SURFACE_INNER_VARIANT]: [TailwindCommonPalette.WHITE],
  [PortalTextType.SURFACE_INNER_VARIANT_2]: [TailwindCommonPalette.NEUTRAL_300],
  [PortalTextType.SECONDARY]: [TailwindCommonPalette.WHITE],
  [PortalTextType.HEADER]: [TailwindCommonPalette.WHITE],
  [PortalTextType.HEADER_HOVER]: [TailwindCommonPalette.WHITE],
  [PortalTextType.BODY]: [TailwindCommonPalette.NEUTRAL_300],
  [PortalTextType.BODY_VARIANT]: [TailwindCommonPalette.CYAN_300],
  [PortalTextType.FOOTER]: [TailwindCommonPalette.WHITE],
  [PortalTextType.FOOTER_2]: [TailwindCommonPalette.NEUTRAL_300],
  [PortalTextType.FOOTER_HOVER]: [TailwindCommonPalette.CYAN_300],
  [PortalTextType.TOOLTIP]: [TailwindCommonPalette.WHITE],
  [PortalTextType.PRIMARY]: [TailwindCommonPalette.CYAN_500],
  [PortalTextType.ON_PRIMARY]: [TailwindCommonPalette.WHITE],
  [PortalTextType.PRIMARY_HOVER]: [TailwindCommonPalette.CYAN_300],
  [PortalTextType.EDIT_TEXT]: [TailwindCommonPalette.BLACK],
  [PortalShadowType.MAIN]: [TailwindCommonPalette.TRANSPARENT],
  [PortalShadowType.HOVER]: [TailwindCommonPalette.TRANSPARENT],
  [PortalShadowType.SEARCH]: [TailwindCommonPalette.TRANSPARENT],
  [PortalBorderType.SURFACE]: [TailwindExtraPalette.CYAN_50_25],
  [PortalBorderType.SURFACE_VARIANT]: [TailwindExtraPalette.CYAN_50_25],
  [PortalBorderType.SURFACE_INNER]: [TailwindExtraPalette.CYAN_50_25],
  [PortalBorderType.SURFACE_INNER_VARIANT]: [TailwindExtraPalette.CYAN_50_25],
  [PortalBorderType.FOOTER]: [TailwindCommonPalette.TRANSPARENT],
  [PortalBorderType.SURFACE_HOVER]: [TailwindExtraPalette.CYAN_50_75],
  [PortalBorderType.SURFACE_VARIANT_HOVER]: [TailwindExtraPalette.CYAN_50_75],
  [PortalBorderType.SURFACE_INNER_HOVER]: [TailwindExtraPalette.CYAN_50_75],
  [PortalBorderType.PRIMARY]: [TailwindCommonPalette.CYAN_500],
  [PortalBorderType.PRIMARY_HOVER]: [TailwindCommonPalette.CYAN_300],
  [PortalBorderType.EDIT_BORDER]: [TailwindCommonPalette.BLACK],
  [PortalBgType.WARN_SURFACE]: [TailwindExtraPalette.AMBER_500_25],
};
